import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=ec2be6c8&scoped=true"
import script from "./QuotationList.vue?vue&type=script&lang=js"
export * from "./QuotationList.vue?vue&type=script&lang=js"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=ec2be6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2be6c8",
  null
  
)

export default component.exports